import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NftStatState } from './type'
import fetchNftStatBySlug from './actions/fetchNftBySlug'
import { AppState } from 'state'

const initialState: NftStatState = {
  status: 'idle',
  filter: 30,
  items: {}
}

export const nftStatSlice = createSlice({
  name: 'nftstat',
  initialState,
  reducers: {
    changeFilter(state, action: PayloadAction<number>) {
      state.filter = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchNftStatBySlug.rejected, state => {
        state.status = 'failed'
      })
      .addCase(fetchNftStatBySlug.pending, state => {
        state.status = 'loading'
      })
      .addCase(fetchNftStatBySlug.fulfilled, (state, action) => {
        state.status = 'idle'
        state.items = action.payload.items
      })
  }
})

export const selectNftStat = (state: AppState) => state.nftstat

export const { changeFilter } = nftStatSlice.actions

export default nftStatSlice.reducer
